import React from 'react';
import { PageHero } from '../components/PageHero';
import { SquareCard } from '../components/SquareCard';
import { Breadcrumbs } from '../components/Breadcrumbs';
export function ManufacturingHubPage() {
  const sections = [{
    title: 'Our Markets',
    desc: 'The sectors we serve: Defence, Police, Prisons, and Medical.',
    to: '/manufacturing/markets'
  }, {
    title: 'Our Processes',
    desc: 'From concept to delivery: our manufacturing capabilities.',
    to: '/manufacturing/processes'
  }, {
    title: 'Defence Procurement',
    desc: 'Specialist support for defence contracts and tenders.',
    to: '/manufacturing/defence-procurement'
  }, {
    title: 'Our Frameworks',
    desc: 'Approved procurement routes via BlueLight and YPO.',
    to: '/manufacturing/frameworks'
  }, {
    title: 'Our Catalogues',
    desc: 'Download our sector-specific product catalogues.',
    to: '/manufacturing/catalogues'
  }];
  return <>
      <PageHero label="Manufacturing" title="Manufacturing Excellence" subtitle="Delivering high-performance equipment through rigorous quality control and ethical supply chains." data-id="element-958" />
      <Breadcrumbs items={[{
      label: 'Manufacturing'
    }]} data-id="element-959" />

      <section className="bg-white py-24" data-id="element-960">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-961">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-962">
            {sections.map(section => <SquareCard key={section.to} to={section.to} title={section.title} description={section.desc} variant="category" actionText="View Section" data-id="element-963" />)}
          </div>
        </div>
      </section>
    </>;
}